import { render, staticRenderFns } from "./pythonBackGround.vue?vue&type=template&id=02b5b6f5&scoped=true"
import script from "./pythonBackGround.vue?vue&type=script&lang=js"
export * from "./pythonBackGround.vue?vue&type=script&lang=js"
import style0 from "./pythonBackGround.vue?vue&type=style&index=0&id=02b5b6f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b5b6f5",
  null
  
)

export default component.exports